module.exports = __webpack_public_path__ + "media/Images/TriangleGreen-6e8a63c4.svg";